import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LoginComponents from "../../components/pages/auth/LoginComponents";
import styles from "./login.module.scss";
import {
  setIsLogin,
  setIsUserStatus,
} from "../../redux/Slices/userSlice";
import { AppDispatch, RootState } from "../../redux/store";
import { fetchTranslation } from "../../redux/Slices/translationDataSlice";

const LoginScreen = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch<AppDispatch>();
  const { data } = useSelector((state: RootState) => state.translationData);
  const initialRender = useRef(true);
  const language = useSelector((state: RootState) => state.language.language);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      if (!data) {
        dispatch(fetchTranslation());
      }
    } else {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);

  useEffect(() => {
    const ref = searchParams.get("ref");
    if (ref) {
      const existingRef = localStorage.getItem("ref");
      // Only write timestamp if this is a new/different ref
      if (existingRef !== ref) {
        localStorage.setItem("ref", ref);
        localStorage.setItem("ref_ts", Date.now().toString());
      }
      dispatch(setIsLogin(false));
      dispatch(setIsUserStatus(true));
    }
  }, [searchParams, dispatch]);

  return (
    <div className={styles.LoginScreen}>
      <div className={styles.row}>
        <div className={styles.loginContainer}>
          <LoginComponents />
        </div>
      </div>
    </div>
  );
};
export default LoginScreen;
